module.exports = __webpack_public_path__ + "img/2.1bd30004.png";